import React from 'react';
import { ImportResults } from './ImportResults';
import { ErrorResults } from './ErrorResults';

export const UploadResults = ({
  uploadOk,
  results,
  token,
  subsidiaryId,
  onCampaignSubscribe,
  onCampaignConfirmed,
  onCampaignReset,
  fileName,
  onImportConfirmed,
  onCanImportChange,
  triggerImport,
  hideModal,
}) => {

  return (
    <div>
      {uploadOk && (
        <ImportResults
          data={results}
          subsidiaryId={subsidiaryId}
          token={token}
          onCampaignSubscribe={onCampaignSubscribe}
          onCampaignConfirmed={onCampaignConfirmed}
          onCampaignReset={onCampaignReset}
          fileName={fileName}
          onImportConfirmed={onImportConfirmed}
          onCanImportChange={onCanImportChange}
          triggerImport={triggerImport}
          hideModal={hideModal}
        />
      )}
      {!uploadOk && (
        <ErrorResults 
          errors={results?.errors || results} 
          fileName={fileName}
          data={results?.data}
          errorType={results?.errorType}
          message={results?.message}
        />
      )}
    </div>
  );
};
